import http from './request'

// 获取抽奖方案
export const getLotteryPlan = (data) => {
  return http({
    url: '/promotion/LotteryPlan/getLotteryLitePlan',
    method: 'post',
    data
  })
}

// 抽奖，轻量奖盘
export const doLotteryLite = (data) => {
  return http({
    url: '/promotion/Lottery/doLotteryLite',
    method: 'post',
    data
  })
}


